import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

export const WELLSPAN_PRODUCTION = {
  [UserRole.ADMINISTRATOR]: [
    Permissions.COMMUNITY_OUTREACH,
    Permissions.GENETIC_COUNSELING,
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CAN_VIEW_PHI,
  ],
  [UserRole.EXECUTIVE]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER_LIMITED_PHI]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.MEMBER]: [
    Permissions.COMMUNITY_OUTREACH,
    Permissions.GENETIC_COUNSELING,
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.CDC_TIER1_METRICS,
    Permissions.CAMPAIGN_TRACKING,
    Permissions.CAN_VIEW_PHI,
  ],
};
